import React, { Component } from 'react'
import style from './Sidebar.scss'
import EditNode from '../EditNode/EditNode'

class Sidebar extends Component {
  handleColorChange(test, color, event) {
    this.props.updateTheme('alpha', 'color', color.hex)
  }
  handlePickerInput(group, property, color, event) {
    this.handleColorChange(color, event)
  }
  render() {
    return (
      <div className={style.sidebar}>
        <EditNode
          title="Alphas"
          group="alpha"
          data={this.props.theme.alpha}
          updateTheme={this.props.updateTheme}
        />
        <EditNode
          title="Number Row"
          group="numberRow"
          data={this.props.theme.numberRow}
          updateTheme={this.props.updateTheme}
        />
        <EditNode
          title="Modifiers"
          group="modifier" 
          data={this.props.theme.modifier}
          updateTheme={this.props.updateTheme}
        />
        <EditNode
          title="Escape"
          group="esc" 
          data={this.props.theme.esc}
          updateTheme={this.props.updateTheme}
        />
        <EditNode
          title="Delete"
          group="delete"  
          data={this.props.theme.delete}
          updateTheme={this.props.updateTheme}
        />
        <EditNode
          title="Enter"
          group="enter"  
          data={this.props.theme.enter}
          updateTheme={this.props.updateTheme}
        />
        <EditNode
          title="Spacebar"
          group="space"  
          data={this.props.theme.space}
          updateTheme={this.props.updateTheme}
        />
        <EditNode
          title="Case"
          group="caseColor" 
          data={this.props.theme.caseColor}
          updateTheme={this.props.updateTheme}
        />
        {/* <EditNode title="Themes" /> */}
        {/* <div className={style.footer}>
          <form>
            <input placegolder="Name"/>
            <textarea>A great idea?</textarea>
          </form>
        </div> */}
      </div>
    )
  }
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js